module.exports = __webpack_public_path__ + "img/20190923172139881.91811e80.jpg";